import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[insertionPoint]',
    standalone: false
})
export class InsertionPointDirective {

    constructor(public viewContainerRef: ViewContainerRef) { }
}
